import React from "react";
import { useTheme } from "@mui/material/styles";
import Navbar from "../components/NavBar/Navbar";
import Breadcrumbs from "../components/Article_Display_Page/Breadcrumbs";
import ArticleView from "../components/Article_Display_Page/ArticleView";
import Footer from "../components/Shared/Footer";
import { useTranslation } from "../hooks/useTranslation";

const CookiePolicy = () => {
  const theme = useTheme();
  const { t, language } = useTranslation();

  const getCookieContent = () => {
    if (language === "pl") {
      return `
        <p><i>Ostatnia aktualizacja: 5 lutego 2026</i></p>

        <p>Niniejsza Polityka Cookies wyjaśnia, w jaki sposób używamy plików cookie oraz podobnych technologii (np. localStorage) w Serwisie Zielona Chatka.</p>

        <h2>1. Czym są pliki cookie i podobne technologie?</h2>
        <p><strong>Pliki cookie</strong> to małe pliki zapisywane w Twojej przeglądarce. <strong>LocalStorage</strong> to pamięć przeglądarki, w której możemy zapisać np. Twoje wybory dotyczące zgód. W prawie UE/PL zasady zgody dotyczą także podobnych technologii.</p>

        <h2>2. Jakich kategorii używamy?</h2>
        <ul>
          <li><strong>Niezbędne</strong> – zapewniają działanie Serwisu (np. podstawowe funkcje koszyka/zamówienia, bezpieczeństwo). Te elementy mogą działać bez zgody.</li>
          <li><strong>Preferencje</strong> – zapamiętują ustawienia (np. język), jeśli je włączysz.</li>
          <li><strong>Analityczne</strong> – obecnie <strong>nie używamy</strong> plików cookie analitycznych/statystycznych.</li>
          <li><strong>Marketingowe</strong> – obecnie <strong>nie używamy</strong> plików cookie marketingowych / reklamowych.</li>
        </ul>

        <h2>3. Zgoda i zarządzanie ustawieniami</h2>
        <p>Podczas pierwszej wizyty wyświetlamy baner zgód. W każdej chwili możesz zmienić decyzję poprzez link <strong>Ustawienia cookies</strong> w stopce.</p>

        <h2>4. Co zapisujemy u Ciebie?</h2>
        <p>Aby pamiętać Twoje wybory, zapisujemy rekord zgód w pamięci przeglądarki (localStorage). Ten zapis jest techniczny i nie służy marketingowi.</p>

        <h2>5. Kontakt</h2>
        <p>W sprawach cookies i prywatności skontaktuj się z nami:</p>
        <ul>
          <li>E-mail: contact@zielonachatka.com</li>
        </ul>
      `;
    }

    return `
      <p><i>Last updated: February 5, 2026</i></p>

      <p>This Cookie Policy explains how Zielona Chatka uses cookies and similar technologies (e.g. localStorage) on the Website.</p>

      <h2>1. What are cookies and similar technologies?</h2>
      <p><strong>Cookies</strong> are small files stored by your browser. <strong>localStorage</strong> is browser storage that can be used to remember choices such as your consent preferences.</p>

      <h2>2. Categories</h2>
      <ul>
        <li><strong>Necessary</strong> – required for the site to work (e.g. core ordering/cart behavior, security). These can run without consent.</li>
        <li><strong>Preferences</strong> – remember settings (e.g. language) if you enable them.</li>
        <li><strong>Analytics</strong> – we currently <strong>do not use</strong> analytics/statistical cookies.</li>
        <li><strong>Marketing</strong> – we currently <strong>do not use</strong> marketing/advertising cookies.</li>
      </ul>

      <h2>3. Managing consent</h2>
      <p>You can change your choice at any time using the <strong>Cookie settings</strong> link in the footer.</p>

      <h2>4. What we store</h2>
      <p>We store your consent preferences in browser storage so we can remember your choices.</p>

      <h2>5. Contact</h2>
      <ul>
        <li>Email: contact@zielonachatka.com</li>
      </ul>
    `;
  };

  const blogArticleDetails = {
    blogTitle: t("cookiePolicy"),
    blogAuthor: "Zielona Chatka",
    blogContent: getCookieContent(),
  };

  return (
    <div style={{ backgroundColor: theme.palette.common.background }}>
      <Navbar />
      <Breadcrumbs title="cookiePolicy" />
      <ArticleView blogArticleDetails={blogArticleDetails} />
      <Footer />
    </div>
  );
};

export default CookiePolicy;
